import React from 'react'
import { ThemeProvider } from '@/lib/styles'

function LoginPage() {
  return <ThemeProvider></ThemeProvider>
}

export default LoginPage
